import { request } from "./request";

export const fetchItems = (ids, type, context = $("body"), admin, expressionObj = "", returnProps = "") => {
	let params = {
		reqId: admin ? "43cadc06-4c2c-47da-a19a-7b0189365d65" : "70f78b98-a1b0-4774-b949-c6006705eb0c",
		data: ids.map(item => ({
			type: type,
			id: item.id
		}))
	};
	if (expressionObj) {
		params = Object.assign(params, expressionObj);
	}
	if (returnProps) {
		params.returnProps = returnProps;
	}
	return new Promise(async (resolve, reject) => {
		try {
			const response = await request(params, context, []);
			if (response.Responses) {
				const table = Object.keys(response.Responses)[0];
				// 'newsroom' || 'newsroom-dev'
				resolve(response.Responses[table]);
			}
		} catch (err) {
			console.error(err);
			reject(`Could not retrieve items`);
		}
	});
};
// get newsroom items from ID value array
